'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssScrollHelper = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _consts = require('photography-client-lib/dist/src/utils/consts');

var _consts2 = _interopRequireDefault(_consts);

var _index = require('../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _experimentsWrapper = require('photography-client-lib/dist/src/sdk/experimentsWrapper');

var _experimentsWrapper2 = _interopRequireDefault(_experimentsWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    TODO:
    - handle horizontal scroll
    - check Layout creation and do not recreate exisiting layouts
*/

var CssScrollHelper = function () {
  function CssScrollHelper() {
    (0, _classCallCheck3.default)(this, CssScrollHelper);

    this.pgScrollSteps = [10240, 5120, 2560, 1280, 640, 320, 160, 80, 40, 20, 10];
    this.pgScrollClassName = 'pgscl';

    this.screenSize = Math.max(_windowWrapper2.default.screen.width, _windowWrapper2.default.screen.height);

    this.scrollCss = [];
    this.scrollCssProps = [];
    this.calcScrollPaddings();
  }

  (0, _createClass3.default)(CssScrollHelper, [{
    key: 'calcScrollPaddings',
    value: function calcScrollPaddings() {
      var _this = this;

      //padding: [belowScreen, aboveScreen]
      //padding: [above images, below image]
      this.allPagePadding = function () {
        return [Infinity, Infinity];
      };
      this.inScreenPadding = function () {
        return [0, 0];
      };
      this.aboveScreenPadding = function () {
        return [0, Infinity];
      };
      this.justBelowScreenPadding = function (itemHeight) {
        return [5120, -1 * (itemHeight + _this.screenSize)];
      };
      this.justBelowAndInScreenPadding = function () {
        return [5120, 0];
      };
      this.belowScreenPadding = function () {
        return [Infinity, 0];
      };

      var highResPadding = void 0;
      var lowResPadding = void 0;
      var scrollPreloading = _experimentsWrapper2.default['specs.pro-gallery.scrollPreloading'];

      switch (scrollPreloading) {
        case '0':
          highResPadding = [0, 0];
          lowResPadding = [0, 0];
          break;
        case '20':
          highResPadding = [640, 2560];
          lowResPadding = [1280, 2560];
          break;
        case '40':
          highResPadding = [1280, 5120];
          lowResPadding = [2560, 5120];
          break;
        case '60':
          highResPadding = [2560, 10240];
          lowResPadding = [5120, 10240];
          break;
        case '100':
          highResPadding = [Infinity, Infinity];
          lowResPadding = [Infinity, Infinity];
          break;
        default:
        case '80':
          highResPadding = [5120, Infinity];
          lowResPadding = [10240, Infinity];
          break;
      }

      this.highResPadding = function () {
        return highResPadding || [5120, Infinity];
      };
      this.lowResPadding = function () {
        return lowResPadding || [10240, Infinity];
      };
    }
  }, {
    key: 'getDomId',
    value: function getDomId(_ref) {
      var id = _ref.id;

      var shortId = String(id).replace(/[\W]+/g, '');
      return 'pgi' + shortId;
    }
  }, {
    key: 'buildScrollClassName',
    value: function buildScrollClassName(galleryDomId, idx, val) {
      var shortId = String(galleryDomId).replace(/[\W]+/g, '').slice(-8);
      return this.pgScrollClassName + '_' + shortId + '_' + val + '-' + (this.pgScrollSteps[idx] + Number(val));
    }
  }, {
    key: 'calcScrollClasses',
    value: function calcScrollClasses(galleryDomId, scrollTop) {
      var _this2 = this;

      return this.pgScrollClassName + '-' + scrollTop + ' ' + this.pgScrollSteps.map(function (step, idx) {
        return _this2.buildScrollClassName(galleryDomId, idx, Math.floor(scrollTop / step) * step);
      }).join(' ');
    }
  }, {
    key: 'calcScrollCss',
    value: function calcScrollCss(_ref2) {
      var _this3 = this;

      var galleryDomId = _ref2.galleryDomId,
          items = _ref2.items,
          styleParams = _ref2.styleParams;

      if (!(items && items.length)) {
        return '';
      }
      this.screenSize = styleParams.oneRow ? Math.min(_windowWrapper2.default.innerWidth, _windowWrapper2.default.screen.width) : Math.min(_windowWrapper2.default.innerHeight, _windowWrapper2.default.screen.height);
      this.calcScrollPaddings();

      var _items$slice = items.slice(-1),
          _items$slice2 = (0, _slicedToArray3.default)(_items$slice, 1),
          lastItem = _items$slice2[0];

      var _lastItem$offset = lastItem.offset,
          top = _lastItem$offset.top,
          right = _lastItem$offset.right;

      var maxStep = this.pgScrollSteps[0];
      this.minHeight = 0 - maxStep;
      this.maxHeight = (Math.ceil(((styleParams.oneRow ? right : top) + this.screenSize) / maxStep) + 1) * maxStep;
      return items.map(function (item) {
        return _this3.calcScrollCssForItem({ galleryDomId: galleryDomId, item: item, styleParams: styleParams });
      }).join('\n');
    }
  }, {
    key: 'shouldCalcScrollCss',
    value: function shouldCalcScrollCss(_ref3, styleParams) {
      var id = _ref3.id,
          idx = _ref3.idx,
          top = _ref3.top,
          left = _ref3.left,
          width = _ref3.width,
          resizeWidth = _ref3.resizeWidth,
          maxWidth = _ref3.maxWidth,
          height = _ref3.height,
          resizeHeight = _ref3.resizeHeight,
          maxHeight = _ref3.maxHeight,
          resized_url = _ref3.resized_url,
          type = _ref3.type;

      if (type === 'video' || type === 'text') {
        return false;
      }
      return true;
      // if (!this.scrollCss[idx]) {
      //   return true; //recalc as long as no css was created
      // }
      // const scrollCssProps = JSON.stringify({id, idx, top, left, width, resizeWidth, maxWidth, height, resizeHeight, maxHeight, resized_url, oneRow: styleParams.oneRow, loadingMode: styleParams.imageLoadingMode, isSSR: window.isSSR});
      // if (scrollCssProps === this.scrollCssProps[idx]) {
      //   return false;
      // }
      // this.scrollCssProps[idx] = scrollCssProps;
      // return true;
    }
  }, {
    key: 'createScrollSelectorsFunction',
    value: function createScrollSelectorsFunction(_ref4) {
      var _this4 = this;

      var galleryDomId = _ref4.galleryDomId,
          item = _ref4.item,
          styleParams = _ref4.styleParams;

      var imageTop = styleParams.oneRow ? item.offset.left - this.screenSize : item.offset.top - this.screenSize;
      var imageBottom = styleParams.oneRow ? item.offset.left + item.width : item.offset.top + item.height;
      var minStep = this.pgScrollSteps[this.pgScrollSteps.length - 1];
      var ceil = function ceil(num, step) {
        return Math.ceil(Math.min(_this4.maxHeight, num) / step) * step;
      };
      var floor = function floor(num, step) {
        return Math.floor(Math.max(_this4.minHeight, num) / step) * step;
      };
      var domId = this.getDomId(item);
      return function (padding, suffix) {
        var _padding = (0, _slicedToArray3.default)(padding, 2),
            before = _padding[0],
            after = _padding[1];

        if (before === Infinity && after === Infinity) {
          return '#' + domId + ' ' + suffix;
        }
        var from = floor(imageTop - before, minStep);
        var to = ceil(imageBottom + after, minStep);
        if (_index2.default.isVerbose()) {
          console.log('CSS SCROLL - item #' + item.idx + ' display range is: (' + from + ' - ' + to + ')');
        }
        var scrollClasses = [];
        while (from < to) {
          var largestDividerIdx = _this4.pgScrollSteps.findIndex(function (step) {
            return from % step === 0 && from + step <= to;
          }); //eslint-disable-line
          if (largestDividerIdx === -1) {
            console.error('largestDividerIdx is -1. Couldn\'t find index in pgScrollSteps array.\nfrom =', from, '\nto =', to, '\npadding[0] =', padding[0], '\npadding[1] =', padding[1]);
            break;
          }
          scrollClasses.push('.' + _this4.buildScrollClassName(galleryDomId, largestDividerIdx, from) + ' ~ div #' + domId + ' ' + suffix);
          from += _this4.pgScrollSteps[largestDividerIdx];
          // console.count('pgScroll class created');
        }
        return scrollClasses.join(', ');
      };
    }
  }, {
    key: 'calcScrollCssForItem',
    value: function calcScrollCssForItem(_ref5) {
      var galleryDomId = _ref5.galleryDomId,
          item = _ref5.item,
          styleParams = _ref5.styleParams;
      var resized_url = item.resized_url,
          idx = item.idx;


      if (!this.shouldCalcScrollCss(item, styleParams)) {
        if (_index2.default.isVerbose()) {
          console.log('CSS SCROLL - skipping css calc for item #' + idx, item, this.scrollCss[idx]);
        }
        return this.scrollCss[idx];
      }

      var scrollCss = '';

      var createScrollSelectors = this.createScrollSelectorsFunction({ galleryDomId: galleryDomId, item: item, styleParams: styleParams });

      //load hi-res image + loading transition
      if (!_windowWrapper2.default.isSSR && !item.isDimensionless) {
        scrollCss += createScrollSelectors(this.highResPadding(), '.image-item>canvas') + ('{opacity: 1; transition: opacity .4s linear; background-image: url(' + resized_url.img + ')}');
      }

      //add the blurry image
      if (!_index2.default.deviceHasMemoryIssues() && styleParams.imageLoadingMode !== _consts2.default.loadingMode.COLOR && (!item.isTransparent || _windowWrapper2.default.isSSR) && !item.isDimensionless) {
        scrollCss += createScrollSelectors(this.lowResPadding(), '.image-item') + ('{background-image: url(' + resized_url.thumb + ')}');
      }

      //scrollAnimation [DEMO]
      scrollCss += this.createScrollAnimationsIfNeeded({ idx: idx, item: item, styleParams: styleParams, createScrollSelectors: createScrollSelectors });

      if (_index2.default.isVerbose()) {
        console.log('CSS SCROLL - css calc for item #' + idx, item, this.scrollCss[idx]);
      }

      this.scrollCss[idx] = scrollCss || this.scrollCss[idx];

      return this.scrollCss[idx];
      // console.count('pgScroll item created');
    }
  }, {
    key: 'createScrollAnimationsIfNeeded',
    value: function createScrollAnimationsIfNeeded(_ref6) {
      var idx = _ref6.idx,
          item = _ref6.item,
          styleParams = _ref6.styleParams,
          createScrollSelectors = _ref6.createScrollSelectors;

      var scrollAnimation = styleParams.scrollAnimation;

      if (!scrollAnimation || scrollAnimation === _consts2.default.scrollAnimations.NO_EFFECT) {
        return '';
      }

      var _animationTiming = (idx % 3 + 1) * 100; //100 - 300

      var animationPreparationPadding = this.allPagePadding();
      var animationActivePadding = this.aboveScreenPadding();

      var animationProps = function animationProps(animationName, animationDuration, animationProgression, animationTiming) {
        return animationName + ' ' + animationDuration + 's ' + animationProgression + ' ' + animationTiming + 'ms 1 normal backwards paused;';
      };

      var scrollAnimationCss = '';

      if (scrollAnimation === _consts2.default.scrollAnimations.FADE_IN) {
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, ' .gallery-item-wrapper') + ('{animation: ' + animationProps('scroll-animation-fade-in', 0.8, 'ease-in', _animationTiming) + '}');
        scrollAnimationCss += createScrollSelectors(animationActivePadding, ' .gallery-item-wrapper') + '{animation-play-state: running;}';
      }

      if (scrollAnimation === _consts2.default.scrollAnimations.GRAYSCALE) {
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, ' .gallery-item-wrapper') + ('{animation: ' + animationProps('scroll-animation-grayscale', 0.6, 'ease-in', _animationTiming + 200) + '}');
        scrollAnimationCss += createScrollSelectors(animationActivePadding, ' .gallery-item-wrapper') + '{animation-play-state: running;}';
      }

      if (scrollAnimation === _consts2.default.scrollAnimations.SLIDE_UP) {
        //push down items under screen
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, '') + ('{animation: ' + animationProps('scroll-animation-slide-up', 0.8, 'cubic-bezier(.13,.78,.53,.92)', 0) + '}');
        //push back items in screen
        scrollAnimationCss += createScrollSelectors(animationActivePadding, '') + '{animation-play-state: running;}';
      }

      if (scrollAnimation === _consts2.default.scrollAnimations.EXPAND) {
        //hide items below screen
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, '') + ('{animation: ' + animationProps('scroll-animation-expand', 0.8, 'cubic-bezier(.13,.78,.53,.92)', 0) + '}');
        //show items in screen
        scrollAnimationCss += createScrollSelectors(animationActivePadding, '') + '{animation-play-state: running;}';
      }

      if (scrollAnimation === _consts2.default.scrollAnimations.SHRINK) {
        //hide items below screen
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, '') + ('{animation: ' + animationProps('scroll-animation-shrink', 0.8, 'cubic-bezier(.13,.78,.53,.92)', 0) + '}');
        //show items in screen
        scrollAnimationCss += createScrollSelectors(animationActivePadding, '') + '{animation-play-state: running;}';
      }

      if (scrollAnimation === _consts2.default.scrollAnimations.ZOOM_OUT) {
        //hide items below screen
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, ' .gallery-item-wrapper') + ('{animation: ' + animationProps('scroll-animation-zoom-out', 0.8, 'cubic-bezier(.13,.78,.53,.92)', 0) + '}');
        //show items in screen
        scrollAnimationCss += createScrollSelectors(animationActivePadding, ' .gallery-item-wrapper') + '{animation-play-state: running;}';
      }

      if (scrollAnimation === _consts2.default.scrollAnimations.ONE_COLOR) {
        var oneColorAnimationColor = styleParams.oneColorAnimationColor && styleParams.oneColorAnimationColor.value ? styleParams.oneColorAnimationColor.value : 'transparent';
        //hide items below screen
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, '') + ('{background-color: ' + oneColorAnimationColor + ';}');
        scrollAnimationCss += createScrollSelectors(animationPreparationPadding, ' .gallery-item-wrapper') + ('{animation: ' + animationProps('scroll-animation-fade-in', 0.6, 'ease-in', _animationTiming) + '}');
        //show items in screen
        scrollAnimationCss += createScrollSelectors(animationActivePadding, ' .gallery-item-wrapper') + '{animation-play-state: running;}';
      }

      return scrollAnimationCss;
    }
  }]);
  return CssScrollHelper;
}();

var cssScrollHelper = exports.cssScrollHelper = new CssScrollHelper();

// Testing the best combination of scroll steps (goal is to reduce the number of classe sper item to minimum)
// ----------------------------------------------------------------------------------------------------------
// pgScrollSteps = [1000, 100, 10]; -> 6759 / 354 = 19 classes per item
// pgScrollSteps = [2500, 500, 100, 20]; -> 4137 / 354 = 11.6 classes per item
// pgScrollSteps = [2560, 1280, 640, 320, 160, 80, 40, 20]; -> 2502 / 354 = 7 classes per item
// pgScrollSteps = [5120, 2560, 1280, 640, 320, 160, 80, 40, 20]; -> 2502 / 354 = 7 classes per item
// pgScrollSteps = [5120, 2560, 1280, 640, 320, 160, 80, 40, 20, 10]; -> 2772 / 354 = 7.8 classes per item